/**
 * THE PREPHIKE MARK, a second copy.
 *
 * Admin compiles as its own TypeScript project and cannot import from the
 * candidate app, so the mark is duplicated rather than shared. It must stay
 * identical to `app/web/src/ui/components/Logo.tsx`: the console is the same
 * product seen from the other side, and a different mark there reads as a
 * different company.
 */

const BRAND_GREEN = "#1A4D3C";
const BRAND_PAPER = "#FAFAF8";

export function LogoMark({
  className = "h-8 w-8",
  title,
}: {
  readonly className?: string;
  readonly title?: string;
}) {
  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      role={title === undefined ? undefined : "img"}
      aria-hidden={title === undefined ? true : undefined}
      aria-label={title}
    >
      {title === undefined ? null : <title>{title}</title>}
      <rect width="32" height="32" rx="7" fill={BRAND_GREEN} />
      {/* The steps. */}
      <path
        d="M5.5 26 L10 26 L10 21 L15 21 L15 16 L20 16 L25.5 10.5"
        fill="none"
        stroke={BRAND_PAPER}
        strokeWidth="3"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      {/* The arrowhead leaving the top step. */}
      <path
        d="M20.6 11 L25.5 10.5 L25 15.4"
        fill="none"
        stroke={BRAND_PAPER}
        strokeWidth="3"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
